/* ============================================================
   CurvyRausch Next Gen — globales JS
   Header, Drawer, AJAX-Warenkorb, Predictive Search.
   Läuft komplett über Event-Delegation, damit per Section-
   Rendering-API neu gerenderte Teile weiter funktionieren.
   ============================================================ */
(function(){
  'use strict';
  var CR = window.CR || { routes: {} };
  var R = CR.routes;

  /* ---------- Scroll-Zustand + Nach-oben-Button ----------
     Der eingeklappte Zustand hängt seit dem Aufteilen der Header-Gruppe
     (01.08.2026) an <html class="cr-scrolled"> statt an .cr-header: Er betrifft
     zwei Sections gleichzeitig (Vorteils-Leiste und Navigation im Kopfbereich),
     und als Nachfahren-Selektor unter .cr-header wäre die Regel für die
     Vorteils-Leiste wirkungslos.

     Die Höhenmessung des Platzhalters liegt jetzt in layout/theme.liquid am
     Wrapper .cr-headerstack. Hier steht bewusst KEIN zweiter Messblock mehr —
     vorher schrieben zwei Stellen dieselbe Höhe. */
  var backToTop = document.querySelector('[data-back-to-top]');
  var isScrolled = null;
  var condense = true;

  // Der Kopfbereich meldet über data-condense, ob er sich beim Scrollen
  // verkleinern soll. Ist er aus, wird .cr-scrolled gar nicht erst gesetzt —
  // sonst würde die Höhenmessung im Layout dauerhaft blockiert, obwohl sich
  // gar nichts einklappt. Einmal auslesen und bei Section-Wechseln auffrischen,
  // statt bei jedem Scroll-Ereignis das DOM zu befragen.
  function readCondense(){
    var h = document.querySelector('[data-header]');
    condense = !h || h.getAttribute('data-condense') !== 'false';
    if(!condense){
      document.documentElement.classList.remove('cr-scrolled');
      isScrolled = false;
    }
  }
  readCondense();
  document.addEventListener('shopify:section:load', readCondense);

  window.addEventListener('scroll', function(){
    var scrolled = condense && window.scrollY > 40;
    if(scrolled !== isScrolled){
      isScrolled = scrolled;
      document.documentElement.classList.toggle('cr-scrolled', scrolled);
    }
    if(backToTop){
      backToTop.classList.toggle('show', window.scrollY > 600);
      backToTop.classList.toggle('is-raised', !!document.querySelector('.cr-stickybar.show'));
    }
  }, { passive: true });

  /* ---------- Vorteils-Ticker (nur auf dem Handy sichtbar) ----------
     Als neu startbare Funktion gebaut: Der Theme-Editor rendert die
     Vorteils-Leiste bei jeder Textänderung neu, dabei stirbt das alte
     Listenelement — ohne clearInterval und Neustart bliebe der Ticker danach
     für immer stehen. Die Zeilenhöhe wird außerdem bei jedem Schritt gemessen
     statt geraten; vorher standen hier fest 20px. */
  var uspTimer = null;
  function initUspTicker(){
    if(uspTimer){ clearInterval(uspTimer); uspTimer = null; }
    var list = document.querySelector('[data-usp-ticker-list]');
    if(!list || list.children.length < 2) return;
    list.style.transform = 'translateY(0)';
    var idx = 0;
    var speed = parseInt(list.getAttribute('data-ticker-speed'), 10);
    if(!speed || speed < 1000) speed = 3200;
    uspTimer = setInterval(function(){
      idx = (idx + 1) % list.children.length;
      // offsetHeight ist 0, solange die Leiste am Computer ausgeblendet ist —
      // dann greift der Rückfallwert und der Ticker läuft unsichtbar leer.
      var step = list.children[0].offsetHeight || 20;
      list.style.transform = 'translateY(' + (-idx * step) + 'px)';
    }, speed);
  }
  // Erst im nächsten Frame neu aufsetzen: Beim Entfernen einer Section feuert
  // das Ereignis, bevor das alte Markup aus dem Dokument verschwunden ist.
  function reinitUspTicker(){
    if(window.requestAnimationFrame){ window.requestAnimationFrame(initUspTicker); }
    else { setTimeout(initUspTicker, 0); }
  }
  initUspTicker();
  document.addEventListener('shopify:section:load', reinitUspTicker);
  document.addEventListener('shopify:section:unload', reinitUspTicker);

  /* ---------- Drawer öffnen/schließen (Delegation) ---------- */
  function overlayFor(name){ return document.querySelector('[data-' + name + '-overlay]'); }
  /* Scroll-Sperre für die Seite hinter offenen Drawern (CSS-Regel in base.css).
     Nach jedem Öffnen/Schließen aufrufen — auch nach dem Neurendern in refreshCartUI. */
  function syncScrollLock(){
    document.documentElement.classList.toggle('cr-scroll-lock',
      !!document.querySelector('.cr-drawer-overlay.is-open'));
  }
  document.addEventListener('click', function(e){
    var t;
    if((t = e.target.closest('[data-open-cart]'))){ var o = overlayFor('cart'); if(o) o.classList.add('is-open'); }
    else if((t = e.target.closest('[data-close-cart]'))){ var o2 = overlayFor('cart'); if(o2) o2.classList.remove('is-open'); }
    else if((t = e.target.closest('[data-open-mobmenu]'))){ var m = overlayFor('mobmenu'); if(m) m.classList.add('is-open'); }
    else if((t = e.target.closest('[data-close-mobmenu]'))){ var m2 = overlayFor('mobmenu'); if(m2) m2.classList.remove('is-open'); }
    else if((t = e.target.closest('[data-mobnav-toggle]'))){ t.closest('.cr-mobnav-group').classList.toggle('is-open'); }
    else if((t = e.target.closest('[data-back-to-top]'))){
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    else if((t = e.target.closest('[data-toggle-search]'))){
      var row = document.querySelector('[data-search-row]');
      if(row) row.style.display = (row.style.display === 'none' || !row.style.display) ? 'block' : 'none';
      var inp = row ? row.querySelector('input[type="search"]') : null;
      if(inp && row.style.display === 'block') inp.focus();
    }
    // Klick auf Overlay-Hintergrund schließt
    if(e.target.matches('[data-cart-overlay], [data-mobmenu-overlay]')) e.target.classList.remove('is-open');
    syncScrollLock();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      document.querySelectorAll('.cr-drawer-overlay.is-open').forEach(function(o){ o.classList.remove('is-open'); });
      syncScrollLock();
    }
  });

  /* ---------- Warenkorb-API ---------- */
  function updateCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  function money(cents){
    return (cents/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' €';
  }
  /* KI-Zeichen (EU AI Act, 14.10.2026): products.json liefert zu jedem Medium den Alt-Text —
     steht dort [KI] (gleiche Regel wie snippets/product-card.liquid), bekommt das Bild das Zeichen.
     Das Produkt-Metafeld custom.ki_generiert ist in dieser Antwort nicht enthalten, der Alt-Text reicht. */
  function isKi(p){
    var m = (p.media && p.media.length) ? p.media[0] : null;
    var alt = (m && m.alt) || (p.featured_media && p.featured_media.alt) || '';
    return alt.indexOf('[KI]') > -1;
  }
  function kiBadge(small){
    var pad = small ? 'padding:2px 5px 2px 4px;font-size:8.5px;right:4px;bottom:4px' : 'padding:3px 7px 3px 6px;font-size:9.5px;right:6px;bottom:6px';
    return '<span style="position:absolute;' + pad + ';display:inline-flex;align-items:center;gap:3px;background:rgba(30,20,24,.6);backdrop-filter:blur(4px);color:#fff;font-weight:700;letter-spacing:.03em;border-radius:var(--cr-r-badge);line-height:1;pointer-events:none"><svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor" style="flex:none"><path d="m12 2 2.3 5.1 5.5.6-4.1 3.7 1.2 5.5L12 19.5 6.1 22.6l1.2-5.5L3.2 7.7l5.5-.6z"/></svg>' + (small ? 'KI' : 'KI-generiert') + '</span>';
  }
  /* Eine Produktkarte im CurvyRausch-Karten-Look (Drawer-Upsell + Cart-Recommendations) */
  function cartRecCard(p){
    var img = p.featured_image ? ('<span style="position:relative;flex:none;display:block;width:56px;height:70px"><img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="56" height="70" loading="lazy" style="width:56px;height:70px;object-fit:cover;border-radius:14px;display:block;background:var(--cr-rose-50)">' + (isKi(p) ? kiBadge(true) : '') + '</span>') : '<span style="width:56px;height:70px;border-radius:14px;flex:none;background:var(--cr-rose-50)"></span>';
    var variant = (p.variants && p.variants.length) ? p.variants.filter(function(v){ return v.available; })[0] : null;
    var addAttr = variant ? (' data-quickadd-variant="' + variant.id + '"') : ' disabled';
    var label = variant ? '+ Hinzufügen' : 'Ausverkauft';
    return '<div class="cr-cart-rec" style="display:flex;gap:12px;align-items:center;border:1.5px solid var(--cr-ink-100);border-radius:20px;padding:10px">' +
      '<a href="' + p.url + '" style="display:flex;gap:12px;align-items:center;flex:1;min-width:0;text-decoration:none">' + img +
      '<span style="flex:1;min-width:0"><span style="display:block;font-weight:700;font-size:13.5px;color:var(--text-strong);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + p.title + '</span>' +
      '<span style="display:block;font-size:13px;font-weight:700;color:var(--text-strong);margin-top:2px">' + money(p.price) + '</span></span></a>' +
      '<button type="button" class="cr-quickadd-btn" data-quickadd' + addAttr + ' style="flex:none;background:#fff;color:var(--cr-ink-800);border:1.5px solid var(--cr-ink-800);font-weight:700;font-size:12.5px;padding:9px 14px;border-radius:6px;cursor:pointer;white-space:nowrap">' + label + '</button></div>';
  }
  /* „Passt gut dazu" im Drawer: Empfehlung zum ersten Warenkorb-Artikel */
  function renderCartUpsell(){
    var holder = document.querySelector('[data-cart-upsell]');
    if(!holder || !holder.dataset.firstProduct) return;
    fetch('/recommendations/products.json?product_id=' + holder.dataset.firstProduct + '&limit=1&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data && data.products) || [];
        if(!products.length){ holder.style.display = 'none'; return; }
        var html = '<div style="font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--cr-ink-500);margin-bottom:10px">Passt gut dazu</div>';
        html += cartRecCard(products[0]);
        holder.innerHTML = html;
      })
      .catch(function(){ holder.style.display = 'none'; });
  }
  /* "Das könnte Dir auch gefallen" auf der Warenkorb-Seite */
  function renderCartRecommendations(){
    var holder = document.querySelector('[data-cart-recommendations]');
    if(!holder || !holder.dataset.firstProduct) return;
    fetch('/recommendations/products.json?product_id=' + holder.dataset.firstProduct + '&limit=4&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data && data.products) || [];
        if(!products.length){ holder.style.display = 'none'; return; }
        var html = '<div style="font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--cr-ink-500);margin-bottom:12px">Das könnte Dir auch gefallen</div>';
        html += '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:14px">';
        products.slice(0, 4).forEach(function(p){
          var img = p.featured_image ? ('<span style="position:relative;display:block"><img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=280" alt="" loading="lazy" style="width:100%;aspect-ratio:3/4;object-fit:cover;border-radius:14px;display:block;background:var(--cr-rose-50)">' + (isKi(p) ? kiBadge(false) : '') + '</span>') : '<div style="width:100%;aspect-ratio:3/4;border-radius:14px;background:var(--cr-rose-50)"></div>';
          var variant = (p.variants && p.variants.length) ? p.variants.filter(function(v){ return v.available; })[0] : null;
          var addAttr = variant ? (' data-quickadd-variant="' + variant.id + '"') : ' disabled';
          var label = variant ? '+ Hinzufügen' : 'Ausverkauft';
          html += '<div style="background:#fff;border-radius:20px;box-shadow:var(--shadow-sm);padding:12px">' +
            '<a href="' + p.url + '" style="text-decoration:none">' + img +
            '<div style="font-weight:700;font-size:13.5px;color:var(--text-strong);margin-top:10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + p.title + '</div>' +
            '<div style="font-size:13px;color:var(--text-strong);font-weight:700;margin-top:2px">' + money(p.price) + '</div></a>' +
            '<button type="button" class="cr-quickadd-btn" data-quickadd' + addAttr + ' style="width:100%;margin-top:9px;background:#fff;color:var(--cr-ink-800);border:1.5px solid var(--cr-ink-800);font-weight:700;font-size:12.5px;padding:8px 0;border-radius:6px;cursor:pointer">' + label + '</button></div>';
        });
        html += '</div>';
        holder.innerHTML = html;
      })
      .catch(function(){ holder.style.display = 'none'; });
  }
  function renderRecs(){ renderCartUpsell(); renderCartRecommendations(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', renderRecs); } else { renderRecs(); }

  function refreshCartUI(openDrawer){
    var tasks = [];
    if(document.querySelector('[data-cart-drawer-root]')){
      tasks.push(
        fetch((R.root || '/') + '?sections=cart-drawer')
          .then(function(r){ return r.json(); })
          .then(function(sections){
            var html = sections['cart-drawer'];
            if(!html) return;
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('[data-cart-drawer-root]');
            var current = document.querySelector('[data-cart-drawer-root]');
            if(fresh && current){
              var wasOpen = current.querySelector('.cr-drawer-overlay.is-open');
              current.replaceWith(fresh);
              if(wasOpen || openDrawer) fresh.querySelector('.cr-drawer-overlay').classList.add('is-open');
              syncScrollLock();
              renderCartUpsell();
            }
          })
      );
    }
    if(document.querySelector('[data-main-cart-root]')){
      tasks.push(
        fetch(window.location.pathname + '?sections=main-cart')
          .then(function(r){ return r.json(); })
          .then(function(sections){
            var html = sections['main-cart'];
            if(!html) return;
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('[data-main-cart-root]');
            var current = document.querySelector('[data-main-cart-root]');
            if(fresh && current){ current.replaceWith(fresh); renderCartRecommendations(); }
          })
      );
    }
    return Promise.all(tasks).then(function(){
      return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ updateCount(cart.item_count); });
    });
  }
  function cartChange(key, quantity){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(){ return refreshCartUI(false); });
  }

  /* Rabattcodes: /cart/update.js nimmt ein discount-Feld (kommagetrennt, leer = alle raus).
     Die Antwort meldet pro Code applicable true/false — daraus entsteht die Fehlermeldung
     im Drawer. Der frühere Weg über /discount/CODE lud die ganze Seite neu, klappte den
     Drawer zu und meldete bei falschen Codes gar nichts. */
  function appliedCodes(block){
    return (block.getAttribute('data-applied-codes') || '').split(',').filter(Boolean);
  }
  function updateDiscounts(codes){
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function(r){
      if(!r.ok) throw new Error('cart/update.js: ' + r.status);
      return r.json();
    });
  }
  function showDiscountError(block, text){
    var err = block.querySelector('[data-discount-error]');
    if(err){ err.textContent = text; err.style.display = 'block'; }
  }

  window.CurvyRauschCart = {
    open: function(){ var o = overlayFor('cart'); if(o) o.classList.add('is-open'); syncScrollLock(); },
    close: function(){ var o = overlayFor('cart'); if(o) o.classList.remove('is-open'); syncScrollLock(); },
    refresh: refreshCartUI,
    add: function(body, openDrawer){
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(r){
        if(!r.ok) return r.json().then(function(err){ throw err; });
        return refreshCartUI(openDrawer !== false);
      });
    }
  };

  /* Mengen-Buttons + Entfernen (Drawer + Warenkorb-Seite, Delegation) */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-cart-qty]');
    if(btn){
      var line = btn.closest('[data-cart-line]');
      var valueEl = line.querySelector('[data-cart-qty-value]');
      var current = parseInt(valueEl.textContent, 10) || 1;
      var delta = parseInt(btn.dataset.delta, 10);
      var next = Math.max(0, current + delta);
      if(delta > 0 && line.dataset.cartLineMax){
        var lineMax = parseInt(line.dataset.cartLineMax, 10);
        if(!isNaN(lineMax)){
          if(next > lineMax) next = lineMax;
          if(next === current) return;
        }
      }
      cartChange(btn.dataset.key, next);
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if(rm){ cartChange(rm.dataset.key, 0); return; }

    /* Schnell-Hinzufügen bei „Passt gut dazu" / „Das könnte Dir auch gefallen" */
    var qa = e.target.closest('[data-quickadd]');
    if(qa && qa.dataset.quickaddVariant && !qa.disabled){
      qa.disabled = true;
      var originalLabel = qa.textContent;
      qa.textContent = '…';
      window.CurvyRauschCart.add({ id: qa.dataset.quickaddVariant, quantity: 1 }, !qa.hasAttribute('data-quickadd-stay'))
        .then(function(){ qa.textContent = '✓ Im Warenkorb'; qa.style.background = 'var(--cr-rose-50)'; qa.style.color = 'var(--cr-ink-500)'; })
        .catch(function(){ qa.disabled = false; qa.textContent = originalLabel; });
      return;
    }

    /* Bestell-Anmerkung ein-/ausblenden */
    var nOpen = e.target.closest('[data-note-open]');
    if(nOpen){
      var nblock = nOpen.closest('[data-note-block]');
      nblock.querySelector('[data-note-closed]').style.display = 'none';
      var nrow = nblock.querySelector('[data-note-open-row]');
      nrow.style.display = 'block';
      var ta = nrow.querySelector('[data-cart-note]');
      if(ta) ta.focus();
      return;
    }

    /* Rabattcode-Zeile ein-/ausblenden */
    var dOpen = e.target.closest('[data-discount-open]');
    if(dOpen){
      var block = dOpen.closest('[data-discount-block]');
      block.querySelector('[data-discount-closed]').style.display = 'none';
      var row = block.querySelector('[data-discount-open-row]');
      row.style.display = 'flex';
      var inp = row.querySelector('[data-discount-input]');
      if(inp) inp.focus();
      return;
    }

    /* Rabattcode anwenden — per AJAX, der Drawer bleibt offen */
    var dApply = e.target.closest('[data-discount-apply]');
    if(dApply){
      var dBlock = dApply.closest('[data-discount-block]');
      var dInput = dBlock.querySelector('[data-discount-input]');
      var code = (dInput.value || '').trim();
      if(!code) return;
      var existing = appliedCodes(dBlock);
      if(existing.some(function(c){ return c.toLowerCase() === code.toLowerCase(); })){
        showDiscountError(dBlock, 'Dieser Code ist schon angewendet.');
        return;
      }
      dApply.disabled = true;
      var dLabel = dApply.textContent;
      dApply.textContent = '…';
      updateDiscounts(existing.concat([code]))
        .then(function(cart){
          var entry = (cart.discount_codes || []).filter(function(d){ return d.code.toLowerCase() === code.toLowerCase(); })[0];
          if(entry && entry.applicable){
            return refreshCartUI(false);
          }
          // Abgelehnten Code gleich wieder austragen, sonst hängt er unsichtbar am Warenkorb
          return updateDiscounts(existing).then(function(){
            dApply.disabled = false;
            dApply.textContent = dLabel;
            showDiscountError(dBlock, 'Dieser Code ist leider ungültig oder gerade nicht aktiv.');
          });
        })
        .catch(function(){
          dApply.disabled = false;
          dApply.textContent = dLabel;
          showDiscountError(dBlock, 'Das hat gerade nicht geklappt – bitte versuch es gleich noch einmal.');
        });
      return;
    }

    /* Angewendeten Rabattcode wieder entfernen */
    var dRemove = e.target.closest('[data-discount-remove]');
    if(dRemove){
      var rBlock = dRemove.closest('[data-discount-block]');
      var keep = appliedCodes(rBlock).filter(function(c){ return c.toLowerCase() !== dRemove.dataset.code.toLowerCase(); });
      dRemove.disabled = true;
      updateDiscounts(keep).then(function(){ return refreshCartUI(false); });
      return;
    }
  });

  /* Bestell-Anmerkung speichern (Drawer + Warenkorb-Seite, Delegation) */
  document.addEventListener('change', function(e){
    var note = e.target.closest('[data-cart-note]');
    if(!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  });

  /* ---------- Such-Vorschläge vor der ersten Eingabe (21.08.2026) ----------
     Der Kopfbereich liefert ein <template data-search-defaults> mit beliebten
     Suchbegriffen und zwei Schnell-Links. Solange weniger als 2 Zeichen im
     Feld stehen, zeigt das Panel diese Vorschläge, statt leer zu bleiben.
     Bei jedem Öffnen frisch geklont, weil die Live-Suche das Panel komplett
     überschreibt. Fehlt das Template (z. B. Setting geleert), verhält sich
     die Suche wie vorher. */
  function showSearchDefaults(input){
    var tpl = document.querySelector('template[data-search-defaults]');
    if(!tpl || !('content' in tpl)) return false;
    var form = input.closest('form');
    var panel = form && form.querySelector('[data-predictive-panel]');
    if(!panel) return false;
    panel.innerHTML = '';
    panel.appendChild(tpl.content.cloneNode(true));
    panel.style.display = 'block';
    return true;
  }
  document.addEventListener('focusin', function(e){
    var input = e.target.closest('[data-predictive-input]');
    if(!input) return;
    if(input.value.trim().length < 2) showSearchDefaults(input);
  });

  /* ---------- Predictive Search ---------- */
  var debounceTimer = null;
  document.addEventListener('input', function(e){
    /* Tippen im Rabattfeld blendet eine alte Fehlermeldung wieder aus */
    var dInp = e.target.closest('[data-discount-input]');
    if(dInp){
      var dblk = dInp.closest('[data-discount-block]');
      var derr = dblk && dblk.querySelector('[data-discount-error]');
      if(derr) derr.style.display = 'none';
      return;
    }
    var input = e.target.closest('[data-predictive-input]');
    if(!input || !R.predictive) return;
    var panel = input.closest('form').querySelector('[data-predictive-panel]');
    if(!panel) return;
    var q = input.value.trim();
    clearTimeout(debounceTimer);
    if(q.length < 2){
      if(!showSearchDefaults(input)){ panel.style.display = 'none'; panel.innerHTML = ''; }
      return;
    }
    debounceTimer = setTimeout(function(){
      fetch(R.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
        .then(function(r){ return r.text(); })
        .then(function(text){
          var tmp = document.createElement('div');
          tmp.innerHTML = text;
          var results = tmp.querySelector('[data-predictive-results]');
          if(results && results.children.length > 0){
            panel.innerHTML = '';
            panel.appendChild(results);
            var all = document.createElement('a');
            all.href = (R.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
            all.textContent = 'Alle Ergebnisse anzeigen';
            all.setAttribute('style', 'display:block;text-align:center;padding:12px;font-weight:700;font-size:13px;color:var(--cr-rose-700);text-decoration:none');
            panel.appendChild(all);
            panel.style.display = 'block';
          } else {
            panel.style.display = 'none';
          }
        });
    }, 220);
  });
  document.addEventListener('click', function(e){
    if(!e.target.closest('[data-predictive-panel]') && !e.target.closest('[data-predictive-input]')){
      document.querySelectorAll('[data-predictive-panel]').forEach(function(p){ p.style.display = 'none'; });
    }
  });
})();
